<template>
  <div class="ip-apply-page">
    <div class="apply-layout">
      <section class="status-panel">
        <div class="status-icon">
          <i class="el-icon-lock"></i>
        </div>
        <h1>登录 IP 申请</h1>
        <p class="status-text">当前 IP 未在白名单</p>
        <div class="ip-line">
          <span>当前 IP</span>
          <strong>{{ currentIp || '-' }}</strong>
        </div>
        <el-alert
            v-if="submitted"
            title="申请已提交，请等待管理员审核"
            type="success"
            :closable="false"
            show-icon>
        </el-alert>
      </section>

      <section class="form-panel">
        <el-form ref="applyForm" :model="form" :rules="rules" label-width="90px">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="form.username" prefix-icon="el-icon-user" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="申请原因" prop="reason">
            <el-input v-model="form.reason" placeholder="例如：办公网络变更"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.applicantRemark" type="textarea" :rows="4" placeholder="补充说明"></el-input>
          </el-form-item>
          <el-form-item class="action-row">
            <el-button type="primary" icon="el-icon-document-add" :loading="submitting" @click="submitApply">提交申请</el-button>
            <el-button icon="el-icon-back" @click="$router.push('/login')">返回登录</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "IpApply",
  data() {
    return {
      currentIp: '',
      submitted: false,
      submitting: false,
      form: {
        username: '',
        reason: '',
        applicantRemark: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '请输入申请原因', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.initForm()
    this.loadCurrentIp()
  },
  methods: {
    initForm() {
      const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}
      this.currentIp = this.$route.query.ip || ''
      this.form.username = this.$route.query.username || user.username || ''
    },
    loadCurrentIp() {
      request.get('/ip/current').then(res => {
        if (res.code === '200' && res.data) {
          this.currentIp = res.data.ip || this.currentIp
          if (!this.form.username) {
            this.form.username = res.data.username || ''
          }
        }
      }).catch(() => {})
    },
    submitApply() {
      this.$refs.applyForm.validate(valid => {
        if (!valid) {
          return
        }
        this.submitting = true
        request.post('/ip/apply', this.form).then(res => {
          if (res.code === '200') {
            this.submitted = true
            this.$message.success('申请已提交')
          } else {
            this.$message.error(res.msg || '提交失败')
          }
        }).catch(() => {
        }).then(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style scoped>
.ip-apply-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: #f4f7fb;
}

.apply-layout {
  width: min(920px, 100%);
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  background: #fff;
  border: 1px solid #e5e9f2;
  border-radius: 8px;
  box-shadow: 0 18px 45px rgba(35, 49, 79, 0.12);
  overflow: hidden;
}

.status-panel {
  padding: 36px 28px;
  background: #1f2937;
  color: #fff;
}

.status-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f59e0b;
  color: #111827;
  font-size: 24px;
  margin-bottom: 22px;
}

.status-panel h1 {
  margin: 0;
  font-size: 26px;
  line-height: 1.3;
  font-weight: 600;
}

.status-text {
  margin: 12px 0 28px;
  color: #d1d5db;
  line-height: 1.6;
}

.ip-line {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  margin-bottom: 20px;
}

.ip-line span {
  color: #cbd5e1;
  font-size: 13px;
}

.ip-line strong {
  color: #fff;
  font-size: 18px;
  word-break: break-all;
}

.form-panel {
  padding: 42px 44px 32px;
}

.action-row {
  margin-bottom: 0;
}

@media (max-width: 760px) {
  .ip-apply-page {
    align-items: flex-start;
    padding: 16px;
  }

  .apply-layout {
    grid-template-columns: 1fr;
  }

  .status-panel {
    padding: 28px 22px;
  }

  .form-panel {
    padding: 28px 22px 22px;
  }
}
</style>
